import { render, staticRenderFns } from "./TrajectoryRecord.vue?vue&type=template&id=663e9666&scoped=true&"
import script from "./TrajectoryRecord.vue?vue&type=script&lang=js&"
export * from "./TrajectoryRecord.vue?vue&type=script&lang=js&"
import style0 from "./TrajectoryRecord.vue?vue&type=style&index=0&id=663e9666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e9666",
  null
  
)

export default component.exports